import '@scss/landing/promo/tagwalk_for_education.scss';
import { Router } from "@js/common/router";
import { sendForm } from "@js/common/contactForm";
import { initCaptcha } from "../hcaptcha";
document.addEventListener('DOMContentLoaded', function () {
    sendContactForm();
});
var sendContactForm = function () {
    var form = document.querySelector('#contactForm');
    var button = form.querySelector('#contactButton');
    if (!form || !button) {
        return;
    }
    var captchaToken = '';
    initCaptcha().then(function (token) {
        captchaToken = token;
    });
    button.addEventListener('click', function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var firstName = (_a = form.querySelector('#firstname')) === null || _a === void 0 ? void 0 : _a.value;
        var lastName = (_b = form.querySelector('#lastname')) === null || _b === void 0 ? void 0 : _b.value;
        var workEmailAddress = (_c = form.querySelector('#workEmailAddress')) === null || _c === void 0 ? void 0 : _c.value;
        var workPhoneNumber = (_d = form.querySelector('#workPhoneNumber')) === null || _d === void 0 ? void 0 : _d.value;
        var school = (_e = form.querySelector('#school')) === null || _e === void 0 ? void 0 : _e.value;
        var jobTitle = (_f = form.querySelector('#jobTitle')) === null || _f === void 0 ? void 0 : _f.value;
        var country = (_g = form.querySelector('#country')) === null || _g === void 0 ? void 0 : _g.value;
        var body = {
            'first_name': firstName,
            'last_name': lastName,
            'email': workEmailAddress,
            'phone_number': workPhoneNumber,
            'school': school,
            'job_title': jobTitle,
            'country': country,
            'h-captcha-response': captchaToken,
        };
        var path = Router.generate('tagwalk_for_education_contact_create');
        sendForm(form, button, path, body);
    });
};
